export default __webpack_public_path__ + "static/media/aleo-v4-latin-regular.9416b9c0.woff";